import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["legitimateInterestPrivacyPolicyText", "implicitProcessingConsentText", "communicationConsentCheckboxes"];
import LegalConsentCheckbox from 'MeetingsBase/models/LegalConsentCheckbox';
import { IMPLICIT_PROCESSING_CONSENT_TYPE, LAWFUL_BASIS_PQL } from 'MeetingsBase/constants/legalConsent';
export const parseHtmlString = htmlString => new DOMParser().parseFromString(htmlString, 'text/html');
const isEmptyHTML = text => {
  return parseHtmlString(text).body.innerText.trim() === '';
};
export const isEmptyParagraph = text => !text || text === '<p></p>' || isEmptyHTML(text);
function isLegalConsentObject(json) {
  return !!json.processingConsentText;
}
const defaults = {
  communicationConsentCheckboxes: [new LegalConsentCheckbox()],
  communicationConsentText: '',
  implicitProcessingConsentText: '',
  isLegitimateInterest: false,
  legitimateInterestLegalBasis: LAWFUL_BASIS_PQL,
  legitimateInterestPrivacyPolicyText: '',
  legitimateInterestSubscriptionTypes: [],
  privacyPolicyText: '',
  processingConsentText: '',
  processingConsentType: ''
};
export default class LegalConsentOptions {
  constructor(props = {}) {
    var _props$communicationC, _props$communicationC2, _props$implicitProces, _props$isLegitimateIn, _props$legitimateInte, _props$legitimateInte2, _props$legitimateInte3, _props$privacyPolicyT, _props$processingCons, _props$processingCons2;
    this.communicationConsentCheckboxes = (_props$communicationC = props.communicationConsentCheckboxes) !== null && _props$communicationC !== void 0 ? _props$communicationC : defaults.communicationConsentCheckboxes;
    this.communicationConsentText = (_props$communicationC2 = props.communicationConsentText) !== null && _props$communicationC2 !== void 0 ? _props$communicationC2 : defaults.communicationConsentText;
    this.implicitProcessingConsentText = (_props$implicitProces = props.implicitProcessingConsentText) !== null && _props$implicitProces !== void 0 ? _props$implicitProces : defaults.implicitProcessingConsentText;
    this.isLegitimateInterest = (_props$isLegitimateIn = props.isLegitimateInterest) !== null && _props$isLegitimateIn !== void 0 ? _props$isLegitimateIn : defaults.isLegitimateInterest;
    this.legitimateInterestLegalBasis = (_props$legitimateInte = props.legitimateInterestLegalBasis) !== null && _props$legitimateInte !== void 0 ? _props$legitimateInte : defaults.legitimateInterestLegalBasis;
    this.legitimateInterestPrivacyPolicyText = (_props$legitimateInte2 = props.legitimateInterestPrivacyPolicyText) !== null && _props$legitimateInte2 !== void 0 ? _props$legitimateInte2 : defaults.legitimateInterestPrivacyPolicyText;
    this.legitimateInterestSubscriptionTypes = (_props$legitimateInte3 = props.legitimateInterestSubscriptionTypes) !== null && _props$legitimateInte3 !== void 0 ? _props$legitimateInte3 : defaults.legitimateInterestSubscriptionTypes;
    this.privacyPolicyText = (_props$privacyPolicyT = props.privacyPolicyText) !== null && _props$privacyPolicyT !== void 0 ? _props$privacyPolicyT : defaults.privacyPolicyText;
    this.processingConsentText = (_props$processingCons = props.processingConsentText) !== null && _props$processingCons !== void 0 ? _props$processingCons : defaults.processingConsentText;
    this.processingConsentType = (_props$processingCons2 = props.processingConsentType) !== null && _props$processingCons2 !== void 0 ? _props$processingCons2 : defaults.processingConsentType;
  }
  static from(json) {
    if (json) {
      return new LegalConsentOptions({
        isLegitimateInterest: json.isLegitimateInterest || false,
        legitimateInterestPrivacyPolicyText: LegalConsentOptions.getLegitimateInterestText(json),
        legitimateInterestSubscriptionTypes: LegalConsentOptions.getLegitimateInterestSubscriptions(json),
        legitimateInterestLegalBasis: json.legitimateInterestLegalBasis || LAWFUL_BASIS_PQL,
        communicationConsentText: json.communicationConsentText,
        communicationConsentCheckboxes: LegalConsentOptions.getCheckboxConfig(json),
        privacyPolicyText: json.privacyPolicyText,
        implicitProcessingConsentText: LegalConsentOptions.getProcessingText(json),
        processingConsentText: json.processingConsentText,
        processingConsentType: json.processingConsentType
      });
    }
    return new LegalConsentOptions();
  }
  static getLegitimateInterestText(json) {
    if (json.isLegitimateInterest) {
      return json.privacyPolicyText;
    }
    return json.legitimateInterestPrivacyPolicyText || '';
  }
  static getCheckboxConfig(json) {
    const checkboxConfig = json.communicationConsentCheckboxes;
    if (checkboxConfig && !!checkboxConfig.map && json.communicationConsentCheckboxes) {
      return json.communicationConsentCheckboxes.map(checkbox => new LegalConsentCheckbox(checkbox));
    }
    return [new LegalConsentCheckbox()];
  }
  static getLegitimateInterestSubscriptions(json) {
    const subscriptionsConfig = json.legitimateInterestSubscriptionTypes;
    if (subscriptionsConfig && !!subscriptionsConfig.map) {
      return [...subscriptionsConfig];
    }
    return [];
  }
  static getProcessingText(json) {
    if (isLegalConsentObject(json)) {
      return json.processingConsentText;
    }
    return json.implicitProcessingConsentText || '';
  }
  hasSubscription(id) {
    return Boolean(this.communicationConsentCheckboxes.find(subscription => subscription.communicationTypeId === id));
  }
  hasLegitimateInterestSubscription(id) {
    return this.legitimateInterestSubscriptionTypes.includes(id);
  }
  hasEmptySubscription() {
    return Boolean(this.communicationConsentCheckboxes.find(subscription => !subscription.communicationTypeId));
  }
  getNumberOfSubscriptions() {
    return this.communicationConsentCheckboxes.length;
  }
  getSubscriptions() {
    return this.communicationConsentCheckboxes;
  }
  getCheckboxLabels() {
    return this.communicationConsentCheckboxes.map(checkbox => checkbox.label);
  }
  convertToJSON() {
    const _this = this,
      {
        legitimateInterestPrivacyPolicyText,
        implicitProcessingConsentText,
        communicationConsentCheckboxes
      } = _this,
      restProps = _objectWithoutPropertiesLoose(_this, _excluded);
    const result = Object.assign({}, restProps, {
      communicationConsentCheckboxes: communicationConsentCheckboxes.map(cb => cb.toJS()),
      processingConsentText: implicitProcessingConsentText || '',
      processingConsentType: IMPLICIT_PROCESSING_CONSENT_TYPE
    });
    if (this.isLegitimateInterest) {
      result.privacyPolicyText = legitimateInterestPrivacyPolicyText;
    }
    return result;
  }
  equals(other) {
    if (this.communicationConsentText !== other.communicationConsentText || this.implicitProcessingConsentText !== other.implicitProcessingConsentText || this.isLegitimateInterest !== other.isLegitimateInterest || this.legitimateInterestLegalBasis !== other.legitimateInterestLegalBasis || this.legitimateInterestPrivacyPolicyText !== other.legitimateInterestPrivacyPolicyText || this.privacyPolicyText !== other.privacyPolicyText || this.processingConsentText !== other.processingConsentText || this.processingConsentType !== other.processingConsentType || this.legitimateInterestSubscriptionTypes.length !== other.legitimateInterestSubscriptionTypes.length || this.communicationConsentCheckboxes.length !== other.communicationConsentCheckboxes.length) {
      return false;
    }
    for (let i = 0; i < this.legitimateInterestSubscriptionTypes.length; i++) {
      if (this.legitimateInterestSubscriptionTypes[i] !== other.legitimateInterestSubscriptionTypes[i]) {
        return false;
      }
    }
    for (let i = 0; i < this.communicationConsentCheckboxes.length; i++) {
      if (!this.communicationConsentCheckboxes[i].equals(other.communicationConsentCheckboxes[i])) {
        return false;
      }
    }
    return true;
  }
  createdFromNull() {
    return this.equals(LegalConsentOptions.from(null));
  }
  lacksSubscriptionId() {
    return this.communicationConsentCheckboxes && this.communicationConsentCheckboxes[0] && !this.communicationConsentCheckboxes[0].communicationTypeId || this.legitimateInterestSubscriptionTypes.length === 0;
  }
  lacksLegitimateInterestText() {
    return !this.legitimateInterestPrivacyPolicyText;
  }
  lacksLegitimateInterestPrivacyPolicyText() {
    return isEmptyParagraph(this.legitimateInterestPrivacyPolicyText);
  }
  lacksCommunicationConsentText() {
    return isEmptyParagraph(this.communicationConsentText);
  }
  allCheckboxesHaveLabels() {
    return this.communicationConsentCheckboxes.every(checkbox => !isEmptyParagraph(checkbox.label));
  }
  filterEmptyConsentSubscriptions() {
    return new LegalConsentOptions(Object.assign({}, this, {
      communicationConsentCheckboxes: this.communicationConsentCheckboxes.filter(checkbox => Boolean(checkbox.communicationTypeId))
    }));
  }
  filterEmptyLegitimateInterestSubscriptions() {
    return new LegalConsentOptions(Object.assign({}, this, {
      legitimateInterestSubscriptionTypes: this.legitimateInterestSubscriptionTypes.filter(s => Boolean(s))
    }));
  }

  // ---------------------------------------------------------------------------
  // Deprecated backward-compat shims (ImmutableJS Record API)
  // Remove when all callers are migrated off ImmutableJS Record access patterns.
  // ---------------------------------------------------------------------------

  /** @deprecated use direct property access */
  get(key) {
    return this[key];
  }

  /** @deprecated use new LegalConsentOptions({...this, [key]: value}) */
  set(key, value) {
    return new LegalConsentOptions(Object.assign({}, this, {
      [key]: value
    }));
  }

  /** @deprecated use spread or direct mutation */
  update(key, updater) {
    return new LegalConsentOptions(Object.assign({}, this, {
      [key]: updater(this[key])
    }));
  }

  /** @deprecated use spread or Immer for nested updates */
  setIn(path, value) {
    const [key, ...rest] = path;
    if (rest.length === 0) {
      return this.set(key, value);
    }
    if (rest.length === 1) {
      const index = rest[0];
      const arr = [...this[key]];
      arr[index] = value;
      return new LegalConsentOptions(Object.assign({}, this, {
        [key]: arr
      }));
    }
    // 3-level: [key, index, subKey] — element is still a LegalConsentCheckbox Record
    if (rest.length === 2) {
      const [index, subKey] = rest;
      const arr = [...this[key]];
      arr[index] = arr[index].set(subKey, value);
      return new LegalConsentOptions(Object.assign({}, this, {
        [key]: arr
      }));
    }
    return this;
  }

  /** @deprecated use convertToJSON */
  toJS() {
    return this.convertToJSON();
  }

  /** @deprecated use convertToJSON */
  toJSON() {
    return this.convertToJSON();
  }
}